// extracted by mini-css-extract-plugin
export default {"-large":"VtmSVXLgcn2XzYwrexyO","thumbsContainer":"WUl2AHGnIXYXt4xXFTVS","fixedDimensions":"EPdPnAnpuXJMJbqL6QtV"};